'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

let _ = t => t,
    _t;

import FormattedMessage from 'I18n/components/FormattedMessage';
import SkeletonLoadWrapper from 'pricing-pages-unified-ui/components/loading/SkeletonLoadWrapper';
import { hasPricingAndPurchasingSucceededSelector } from 'pricing-pages-unified-ui/selectors/LoadingStateSelectors';
import breakpoint from 'pricing-pages-unified-ui/utils/responsiveBreakpoints';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import * as ProductLevels from 'self-service-api/constants/ProductLevels';
import styled from 'styled-components';
import H1 from 'UIComponents/elements/headings/H1';
import { hasProductLevelOrHigherInProductInventorySelector } from '../../../selectors/ProductInventorySelectors';
import StarterCrmSuiteCard from './StarterCrmSuiteCard';
const Container = styled.div.withConfig({
  displayName: "RecommendedBundlesSection__Container",
  componentId: "sc-1wlomid-0"
})(["text-align:center;", ";"], breakpoint.cs(_t || (_t = _`
    text-align: center !important;
  `)));

const RecommendedBundlesContent = ({
  productLine
}) => {
  const ownsProOrHigher = useSelector(state => hasProductLevelOrHigherInProductInventorySelector(state, {
    productLevel: ProductLevels.PROFESSIONAL
  }));
  const showRecommendedBundlesSection = !ownsProOrHigher;
  if (!showRecommendedBundlesSection) return null;
  return /*#__PURE__*/_jsxs(Container, {
    className: "m-top-10",
    children: [/*#__PURE__*/_jsx(H1, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "recommendedBundles.title"
      })
    }), /*#__PURE__*/_jsx(StarterCrmSuiteCard, {
      productLine: productLine
    })]
  });
};

const RecommendedBundlesSection = ({
  productLine
}) => {
  const hasPricingAndPurchasingSucceeded = useSelector(hasPricingAndPurchasingSucceededSelector);
  return /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
    isLoading: !hasPricingAndPurchasingSucceeded,
    Content: RecommendedBundlesContent,
    contentProps: {
      productLine
    }
  });
};

RecommendedBundlesSection.propTypes = {
  productLine: PropTypes.string.isRequired
};
export default RecommendedBundlesSection;